import { CASHIER_OPEN, CASHIER_CLOSE } from './cashierType';

export const initialState = JSON.parse(
  localStorage.getItem('cashierState')
) || {
  isOpen: false,
};

const cashierReducer = (state = initialState, action) => {
  switch (action.type) {
    case CASHIER_OPEN:
      const openState = {
        ...state,
        isOpen: true,
      };
      localStorage.setItem('cashierState', JSON.stringify(openState));
      return openState;

    case CASHIER_CLOSE:
      // Update the state and save to localStorage
      const closeState = {
        ...state,
        isOpen: false,
      };
      localStorage.setItem('cashierState', JSON.stringify(closeState));
      return closeState;

    default:
      return state;
  }
};

export default cashierReducer;
